import destrict from '../../assets/image/destricts/destrict.jpg'
import cityImage from '../../assets/image/destricts/destrict.jpg'

export const propertyTypeOptions = [
    { value: 'apartment', label: 'ბინა, აპარტამენტი' },
    { value: 'penthouse', label: 'პენტჰაუსი' },
    { value: 'house', label: 'კერძო სახლი - ვილა' },
    { value: 'cottage', label: 'აგარაკი - კოტეჯი' },
    { value: 'townhouse', label: 'თაუნ ჰაუსი' },
    { value: 'atticfloor', label: 'სხვენ-სართული' },
    { value: 'comercialoffice', label: 'კომერციული საოფისე ფართი' },
    { value: 'hotel', label: 'სასტუმრო' },
    { value: 'businesscenter', label: 'ბიზნეს ცენტრი' },
    { value: 'land', label: 'მიწა' },
    { value: 'business', label: 'ბიზნესი - ინვესტიცია' },
    { value: 'farm', label: 'ფერმა' },
];

export const transactionTypeOptions = [
    { value: 'sale', label: 'იყიდება' },
    { value: 'installment', label: 'იყიდება განვადებით' },
    { value: 'rent', label: 'ქირავდება' },
    { value: 'dailyrent', label: 'ქირავდება დღიურად' },
    { value: 'pawn', label: 'გირავდება' },
    { value: 'pawnwithowner', label: 'გირავდება მესაკუთრის ცხოვრების უფლებით' },
    { value: 'mortgage', label: 'იპოთეკა მოგირავნის ცხოვრების უფლებით' },
    { value: 'auction', label: 'იყიდება აუქციონით' },
    { value: 'change', label: 'იცვლება' },
    { value: 'lease', label: 'გაიცემა იჯარით' }
];


export const propertyStatusOptions = [
    { value: 'new', label: 'ახალი აშენებული' },
    { value: 'underconstruction', label: 'მშენებარე' },
    { value: 'old', label: 'ძველი აშენებული' },
];

export const propertyProjectOptions = [
    { value: 'nonstandard', label: 'არასტანდარტული' },
    // ჩამატებული პროექტი
    { value: 'standard', label: 'სტანდარტული' },
    // ჩამატებული პროექტი
    { value: 'individual', label: 'ინდივიდუალური' },
    { value: 'amkhanagoba', label: 'ამხანაგობა' },
    { value: 'saerto', label: 'საერთო საცხოვრებელი' },
    { value: 'stalinuri', label: 'სტალინური პროექტი' },
    { value: 'czechia', label: 'ჩეხური' },
    { value: 'urban', label: 'ქალაქური' },
    { value: 'khrushchev', label: 'ხრუშოვი' },
    { value: 'kavlashvili', label: 'ყავლაშვილი' },
    { value: 'tukharuli', label: 'თუხარული' },
    { value: 'moscow', label: 'მოსკოვი' },
    { value: 'lvov', label: 'ლვოვი' },
    { value: 'iugoslavia', label: 'იუგოსლავია' },
    { value: 'tashkenti', label: 'ტაშკენტი' },
    { value: 'leningrad', label: 'ლენინგრადი' },
    { value: 'kiev', label: 'კიევი' },
    { value: 'vedzisi', label: 'ვეძისი' },
    { value: 'metromsheni', label: 'მეტრომშენი' },
    { value: 'tbilisi', label: 'თბილისური ეზო' },
    { value: 'hystorical', label: 'ისტრიული შენობა' },
    // { value: 'repair', label: 'სარემონტო მდგომარეობაში' },
];

export const propertyProjectClassOptions = [
    { value: 'premiumbusiness', label: 'პრემიუმ ბიზნეს კლასი' },
    { value: 'premium', label: 'პრემიუმ კლასი' },
    { value: 'medium', label: 'მედიუმ კლასი' },
    { value: 'econom', label: 'ეკონომ კლასი' },
];


// ჩამატებული პროექტის სტილი
export const propertyProjectExterriorStyleOptions = [
    { value: 'antique_greek_roman', label: 'ანტიკური (ბერძნული / რომაული)', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'gothic', label: 'გოთური', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'renaissance', label: 'რენესანსი', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'baroque', label: 'ბაროკო', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'classicism_neoclassicism', label: 'კლასიციზმი / ნეოკლასიციზმი', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'victorian', label: 'ვიქტორიანული', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'art_nouveau', label: 'არ-ნუვო (Art Nouveau)', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'art_deco', label: 'არ-დეკო (Art Deco)', category: 'კლასიკური და ისტორიული სტილები' },
    { value: 'georgian_traditional', label: 'ქართული ტრადიციული (ქართული სახლი — აივნებით, კარ-მიდამოთი)', category: 'ქართული და რეგიონული სტილები' },
    { value: 'georgian_bell_tower_church', label: 'ქართული სამრეკლო / ეკლესიური სტილი', category: 'ქართული და რეგიონული სტილები' },
    { value: 'tbilisi_eclectic_19_20', label: 'თბილისური (XIX–XX სს. ეკლექტიკა, ფერადი აივნები)', category: 'ქართული და რეგიონული სტილები' },
    { value: 'caucasian_tower_military', label: 'კავკასიური სამხედრო-კოშკური სტილი (სვანური, მთიული)', category: 'ქართული და რეგიონული სტილები' },
    { value: 'minimalism', label: 'მინიმალიზმი', category: 'თანამედროვე სტილები' },
    { value: 'modernism', label: 'მოდერნიზმი', category: 'თანამედროვე სტილები' },
    { value: 'contemporary', label: 'კონტემპორარი (Contemporary)', category: 'თანამედროვე სტილები' },
    { value: 'scandinavian_nordic', label: 'სკანდინავიური / ნორდული', category: 'თანამედროვე სტილები' },
    { value: 'industrial_loft', label: 'ინდუსტრიული (Loft / Industrial)', category: 'თანამედროვე სტილები' },
    { value: 'high_tech', label: 'ჰაი-ტეკი (Hi-Tech)', category: 'თანამედროვე სტილები' },
    { value: 'biophilic', label: 'ბიოფილური (Biophilic)', category: 'თანამედროვე სტილები' },
    { value: 'futurism', label: 'ფუტურიზმი', category: 'თანამედროვე სტილები' },
    { value: 'brutalism_soviet_modernism', label: 'ბრუტალიზმი / საბჭოთა მოდერნიზმი', category: 'თანამედროვე სტილები' },
    { value: 'mediterranean', label: 'ხმელთაშუაზღვური (მედიტერანული)', category: 'მიქსი და ეკლექტიკური სტილები' },
    { value: 'tuscan', label: 'ტოსკანური', category: 'მიქსი და ეკლექტიკური სტილები' },
    { value: 'colonial', label: 'კოლონიალური', category: 'მიქსი და ეკლექტიკური სტილები' },
    { value: 'american_traditional', label: 'ამერიკული ტრადიციული (Colonial / Craftsman)', category: 'მიქსი და ეკლექტიკური სტილები' },
    { value: 'japandi', label: 'იაპონური (Japandi)', category: 'მიქსი და ეკლექტიკური სტილები' },
    { value: 'scandinavian_contemporary_mix', label: 'სკანდინავიურ-თანამედროვე', category: 'მიქსი და ეკლექტიკური სტილები' },
];
export const propertyProjectInteriorStyleOptions = [
    { value: 'mid_century_modern', label: 'შუასაუკუნის მოდერნი' },
    { value: 'neo_industrial', label: 'ნეო-ინდუსტრიული' },
    { value: 'traditional', label: 'ტრადიციული' },
    { value: 'transitional', label: 'გარდამავალი' },
    { value: 'maximalist', label: 'მაქსიმალისტური' },
    { value: 'scandinavian', label: 'სკანდინავიური' },
    { value: 'farmhouse', label: 'ფერმის სტილი' },
    { value: 'american', label: 'ამერიკანა' },
    { value: 'rustic', label: 'რუსტიკული' },
    { value: 'minimalist', label: 'მინიმალისტური' },
    { value: 'bohemian', label: 'ბოჰემური' },
    { value: 'mediterranean', label: 'ხმელთაშუაზღვისპირული' },
    { value: 'french_country', label: 'ფრანგული სოფლის სტილი' },
    { value: 'eclectic', label: 'ეკლექტური' },
    { value: 'revival_70s', label: '70-იანების აღორძინება' },
    { value: 'english_cottage', label: 'ინგლისური კოტეჯი' },
    { value: 'art_deco', label: 'არტ დეკო' },
    { value: 'modern_farmhouse', label: 'თანამედროვე ფერმის სტილი' },
    { value: 'contemporary', label: 'თანამედროვე' },
    { value: 'regency', label: 'რეგენტობის სტილი' },
    { value: 'coastal', label: 'სანაპირო' },
    { value: 'grandmillennial', label: 'გრანდმილენიალი' },
    { value: 'memphis', label: 'მემფისი' }
];
// ჩამატებული პროექტის სტილი


export const propertyConditionOptions = [
    { value: 'modern', label: 'თანამედროვე რემონტი (Luxory)' },
    { value: 'newly', label: 'ახალი გარემონტებული' },
    { value: 'ongoing', label: 'მიმდინარე რემონტი' },
    { value: 'white', label: 'თეთრი რემონტი' },
    { value: 'greenframe', label: 'მწვანე კარკასი' },
    { value: 'whiteframe', label: 'თეთრი კარკასი' },
    // დამატებული
    { value: 'white_plus', label: 'თეთრი პლიუსი' },
    // დამატებული
    { value: 'greyframe', label: 'რუხი კარკასი' },
    { value: 'blackframe', label: 'შავი კარკასი' },
    { value: 'underconstruction', label: 'ძველი რემონტი' },
    // damatebuli
    { value: 'frame', label: 'კარკასი' },
];

export const statementTypeOptions = [
    { value: 'relux', label: 'RELUX' },
    { value: 'exclusive', label: 'EXCLUSIVE' },
];

export const metroStationOptions = [
    { value: 'metro_akhmetelis_theatre', label: 'ახმეტელის თეატრი' },
    { value: 'metro_sarajishvili', label: 'სარაჯიშვილი' },
    { value: 'metro_guramishvili', label: 'გურამიშვილი' },
    { value: 'metro_ghrmagele', label: 'ღრმაღელე' },
    { value: 'metro_didube', label: 'დიდუბე' },
    { value: 'metro_gociridze', label: 'გოცირიძე' },
    { value: 'metro_nadzaladevi', label: 'ნაძალადევი' },
    { value: 'metro_sadguris_moedani', label: 'სადგურის მოედანი' },
    { value: 'metro_marjanishvili', label: 'მარჯანიშვილი' },
    { value: 'metro_rustaveli', label: 'რუსთაველი' },
    { value: 'metro_tavisuplebis_moedani', label: 'თავისუფლების მოედანი' },
    { value: 'metro_avlabari', label: 'ავლაბარი' },
    { value: 'metro_300_aragveli', label: '300 არაგველი' },
    { value: 'metro_samgori', label: 'სამგორი' },
    { value: 'metro_isani', label: 'ისანი' },
    { value: 'metro_varketili', label: 'ვარკეთილი' },
    { value: 'metro_sadguris_moedani_2', label: 'სადგურის მოედანი 2' },
    { value: 'metro_wereteli', label: 'წერეთელი' },
    { value: 'metro_technical_university', label: 'ტექნიკური უნივერსიტეტი' },
    { value: 'metro_medical_university', label: 'სამედიცინო უნივერსიტეტი' },
    { value: 'metro_delisi', label: 'დელისი' },
    { value: 'metro_vazha_pshavela', label: 'ვაჟა-ფშაველა' },
    { value: 'metro_state_university', label: 'სახელმწიფო უნივერსიტეტი' },
];

export const cityOptions = [
    { value: 'tbilisi', label: 'თბილისი', image: cityImage, popular: 1 },
    { value: 'batumi', label: 'ბათუმი', image: cityImage, popular: 1 },
    { value: 'kutaisi', label: 'ქუთაისი', image: cityImage, popular: 1 },
    { value: 'rustavi', label: 'რუსთავი', image: cityImage, popular: 1 },
    { value: 'poti', label: 'ფოთი', image: cityImage, popular: 1 },
    { value: 'zugdidi', label: 'ზუგდიდი', image: cityImage,  popular: 1},
    { value: 'gori', label: 'გორი', image: cityImage, popular: 1 },
    { value: 'mtskheta', label: 'მცხეთა', image: cityImage, popular: 1 },
    { value: 'telavi', label: 'თელავი', image: cityImage, popular: 1 },
    { value: 'sighnaghi', label: 'სიღნაღი', image: cityImage, popular: 1 },
    { value: 'borjomi', label: 'ბორჯომი', image: cityImage, popular: 1 },
    { value: 'bakuriani', label: 'ბაკურიანი', image: cityImage, popular: 1 },
    { value: 'gudauri', label: 'გუდაური', image: cityImage, popular: 1 },
    { value: 'abastumani', label: 'აბასთუმანი', image: cityImage, popular: 1 },
    { value: 'abasha', label: 'აბაშა', image: cityImage, popular: 0 },
    { value: 'agara', label: 'აგარა', image: cityImage, popular: 0 },
    { value: 'adigeni', label: 'ადიგენი', image: cityImage, popular: 0 },
    // { value: 'algeti', label: 'ალგეთი', image: cityImage, popular: 0 },
    { value: 'ambrolauri', label: 'ამბროლაური', image: cityImage, popular: 0 },
    { value: 'anaklia', label: 'ანაკლია', image: cityImage, popular: 0 },
    { value: 'ananuri', label: 'ანანური', image: cityImage, popular: 1 },
    { value: 'aspindza', label: 'ასპინძა', image: cityImage, popular: 0 },
    { value: 'akhaldaba', label: 'ახალდაბა', image: cityImage, popular: 0 },
    { value: 'akhalgori', label: 'ახალგორი', image: cityImage, popular: 0 },
    { value: 'akhalkalaki', label: 'ახალქალაქი', image: cityImage, popular: 0 },
    { value: 'akhaltsikhe', label: 'ახალციხე', image: cityImage, popular: 1 },
    { value: 'akhmeta', label: 'ახმეტა', image: cityImage, popular: 0 },
    // { value: 'bandza', label: 'ბანძა', image: cityImage, popular: 0 },
    { value: 'baghdati', label: 'ბაღდათი', image: cityImage, popular: 0 },
    { value: 'bakhmaro', label: 'ბახმარო', image: cityImage, popular: 0 },
    // { value: 'boboqvati', label: 'ბობოყვათი', image: cityImage, popular: 0 },
    // { value: 'bodbe', label: 'ბოდბე', image: cityImage, popular: 0 },
    { value: 'bolnisi', label: 'ბოლნისი', image: cityImage, popular: 0 },
    // { value: 'bulachauri', label: 'ბულაჩაური', image: cityImage, popular: 0 },
    // { value: 'gamarjveba', label: 'გამარჯვება', image: cityImage, popular: 0 },
    { value: 'gardabani', label: 'გარდაბანი', image: cityImage, popular: 0 },
    // { value: 'geguti', label: 'გეგუთი', image: cityImage, popular: 0 },
    // { value: 'gombori', label: 'გომბორი', image: cityImage, popular: 0 },
    { value: 'gonio', label: 'გონიო', image: cityImage, popular: 0 },
    //{ value: 'gremi', label: 'გრემი', image: cityImage, popular: 0 },
    { value: 'grigoleti', label: 'გრიგოლეთი', image: cityImage, popular: 0 },
    // { value: 'gulgula', label: 'გულგულა', image: cityImage, popular: 0 },
    { value: 'gurjaani', label: 'გურჯაანი', image: cityImage, popular: 0 },
    // { value: 'danispiruli', label: 'დანისპირული', image: cityImage, popular: 0 },
    { value: 'dedoplistsqaro', label: 'დედოფლისწყარო', image: cityImage, popular: 0 },
    // { value: 'dilikauri', label: 'დილიკაური', image: cityImage, popular: 0 },
    { value: 'dmanisi', label: 'დმანისი', image: cityImage, popular: 0 },
    // { value: 'doesi', label: 'დოესი', image: cityImage, popular: 0 },
    { value: 'dusheti', label: 'დუშეთი', image: cityImage, popular: 1 },
    // { value: 'eniseli', label: 'ენისელი', image: cityImage, popular: 0 },
    // { value: 'vazisubani', label: 'ვაზისუბანი', image: cityImage, popular: 0 },
    { value: 'vani', label: 'ვანი', image: cityImage, popular: 0 },
    // { value: 'vartsikhe', label: 'ვარციხე', image: cityImage, popular: 0 },
    // { value: 'velistsikhe', label: 'ველისციხე', image: cityImage, popular: 0 },
    // { value: 'zana', label: 'ზანა', image: cityImage, popular: 0 },
    // { value: 'zedazeni', label: 'ზედაზენი', image: cityImage, popular: 0 },
    { value: 'zestaponi', label: 'ზესტაფონი', image: cityImage, popular: 0 },
    // { value: 'tetritsqlebi', label: 'თეთრი წყლები', image: cityImage, popular: 0 },
    { value: 'tetritsqaro', label: 'თეთრიწყარო', image: cityImage, popular: 0 },
    { value: 'terjola', label: 'თერჯოლა', image: cityImage, popular: 0 },
    { value: 'tianeti', label: 'თიანეთი', image: cityImage, popular: 0 },
    // { value: 'igoeti', label: 'იგოეთი', image: cityImage, popular: 0 },
    // { value: 'iqalto', label: 'იყალთო', image: cityImage, popular: 0 },
    // { value: 'kavtiskhevi', label: 'კავთისხევი', image: cityImage, popular: 0 },
    // { value: 'kazreti', label: 'კაზრეთი', image: cityImage, popular: 0 },
    // { value: 'kardenakhi', label: 'კარდენახი', image: cityImage, popular: 0 },
    { value: 'kaspi', label: 'კასპი', image: cityImage, popular: 0 },
    // { value: 'kechkhobi', label: 'კეჩხობი', image: cityImage, popular: 0 },
    { value: 'kvariati', label: 'კვარიათი', image: cityImage, popular: 0 },
    { value: 'lagodekhi', label: 'ლაგოდეხი', image: cityImage, popular: 0 },
    { value: 'lanchkhuti', label: 'ლანჩხუთი', image: cityImage, popular: 1 },
    { value: 'likani', label: 'ლიკანი', image: cityImage, popular: 0 },
    // { value: 'manavi', label: 'მანავი', image: cityImage, popular: 0 },
    { value: 'manglisi', label: 'მანგლისი', image: cityImage, popular: 0 },
    { value: 'marneuli', label: 'მარნეული', image: cityImage, popular: 1 },
    { value: 'martvili', label: 'მარტვილი', image: cityImage, popular: 1 },
    // { value: 'martqopi', label: 'მარტყოფი', image: cityImage, popular: 0 },
    // { value: 'matani', label: 'მატანი', image: cityImage, popular: 0 },
    { value: 'makhinjauri', label: 'მახინჯაური', image: cityImage, popular: 0 },
    { value: 'mestia', label: 'მესტია', image: cityImage, popular: 1 },
    // { value: 'metekhi', label: 'მეტეხი', image: cityImage, popular: 0 },
    // { value: 'misaktsieli', label: 'მისაქციელი', image: cityImage, popular: 0 },
    // { value: 'mukuzani', label: 'მუკუზანი', image: cityImage, popular: 0 },
    // { value: 'mukhrani', label: 'მუხრანი', image: cityImage, popular: 0 },
    { value: 'mtsvanekontskhi', label: 'მწვანე კონცხი', image: cityImage, popular: 0 },
    // { value: 'natanebi', label: 'ნატანები', image: cityImage, popular: 0 },
    { value: 'natakhtari', label: 'ნატახტარი', image: cityImage, popular: 0 },
    { value: 'ninotsminda', label: 'ნინოწმინდა', image: cityImage, popular: 0 },
    // { value: 'norio', label: 'ნორიო', image: cityImage, popular: 0 },
    // { value: 'noste', label: 'ნოსტე', image: cityImage, popular: 0 },
    // { value: 'nunisi', label: 'ნუნისი', image: cityImage, popular: 0 },
    // { value: 'odishi', label: 'ოდიში', image: cityImage, popular: 0 },
    { value: 'ozurgeti', label: 'ოზურგეთი', image: cityImage, popular: 0 },
    // { value: 'okami', label: 'ოკამი', image: cityImage, popular: 0 },
    { value: 'oni', label: 'ონი', image: cityImage, popular: 0 },
    // { value: 'pankisi', label: 'პანკისი', image: cityImage, popular: 0 },
    // { value: 'pirvelimaisi', label: 'პირველი მაისი', image: cityImage, popular: 0 },
    { value: 'zhinvali', label: 'ჟინვალი', image: cityImage, popular: 0 },
    // { value: 'rukhi', label: 'რუხი', image: cityImage, popular: 0 },
    { value: 'sagarejo', label: 'საგარეჯო', image: cityImage, popular: 0 },
    // { value: 'sadakhlo', label: 'სადახლო', image: cityImage, popular: 0 },
    // { value: 'sazano', label: 'საზანო', image: cityImage, popular: 0 },
    { value: 'sairme', label: 'საირმე', image: cityImage, popular: 0 },
    { value: 'samtavisi', label: 'სამთავისი', image: cityImage, popular: 0 },
    { value: 'samtredia', label: 'სამტრედია', image: cityImage, popular: 0 },
    // { value: 'sartichala', label: 'სართიჭალა', image: cityImage, popular: 0 },
    // { value: 'sarpi', label: 'სარფი', image: cityImage, popular: 0 },
    { value: 'sachkhere', label: 'საჩხერე', image: cityImage, popular: 0 },
    { value: 'senaki', label: 'სენაკი', image: cityImage, popular: 0 },
    // { value: 'sviri', label: 'სვირი', image: cityImage, popular: 0 },
    // { value: 'simoneti', label: 'სიმონეთი', image: cityImage, popular: 0 },
    { value: 'sioni', label: 'სიონი', image: cityImage, popular: 0 },
    { value: 'surami', label: 'სურამი', image: cityImage, popular: 0 },
    // { value: 'supsa', label: 'სუფსა', image: cityImage, popular: 0 },
    // { value: 'tibaani', label: 'ტიბაანი', image: cityImage, popular: 0 },
    { value: 'tqibuli', label: 'ტყიბული', image: cityImage, popular: 0 },
    { value: 'ureki', label: 'ურეკი', image: cityImage, popular: 0 },
    // { value: 'utsera', label: 'უწერა', image: cityImage, popular: 0 },
    // { value: 'ujarma', label: 'უჯარმა', image: cityImage, popular: 0 },
    { value: 'pasanauri', label: 'ფასანაური', image: cityImage, popular: 0 },
    // { value: 'pshaveli', label: 'ფშაველი', image: cityImage, popular: 0 },
    { value: 'kareli', label: 'ქარელი', image: cityImage, popular: 0 },
    { value: 'keda', label: 'ქედა', image: cityImage, popular: 0 },
    // { value: 'kvishkheti', label: 'ქვიშხეთი', image: cityImage, popular: 0 },
    // { value: 'kvemoaranisi', label: 'ქვემო არანისი', image: cityImage, popular: 0 },
    { value: 'kobuleti', label: 'ქობულეთი', image: cityImage, popular: 1 },
    // { value: 'ksani', label: 'ქსანი', image: cityImage, popular: 0 },
    // { value: 'kubriantkari', label: 'ქუბრიანთკარი', image: cityImage, popular: 0 },
    // { value: 'kveseti', label: 'კვესეთი', image: cityImage, popular: 0 },
    { value: 'stepantsminda', label: 'სტეფანწმინდა', image: cityImage, popular: 1 },
    { value: 'qvareli', label: 'ყვარელი', image: cityImage, popular: 0 },
    //{ value: 'qulevi', label: 'ყულევი', image: cityImage, popular: 0 },
    // { value: 'shatili', label: 'შატილი', image: cityImage, popular: 0 },
    // { value: 'shekvetili', label: 'შეკვეთილი', image: cityImage, popular: 0 },
    // { value: 'shilda', label: 'შილდა', image: cityImage, popular: 0 },
    // { value: 'shindisi', label: 'შინდისი', image: cityImage, popular: 0 },
    // { value: 'shiomghvime', label: 'შიომღვიმე', image: cityImage, popular: 0 },
    { value: 'shovi', label: 'შოვი', image: cityImage, popular: 0 },
    { value: 'shorapani', label: 'შორაპანი', image: cityImage, popular: 0 },
    // { value: 'shuamta', label: 'შუამთა', image: cityImage, popular: 0 },
    { value: 'shuakhevi', label: 'შუახევი', image: cityImage, popular: 0 },
    { value: 'chakvi', label: 'ჩაქვი', image: cityImage, popular: 0 },
    { value: 'chokhatauri', label: 'ჩოხატაური', image: cityImage, popular: 0 },
    { value: 'chkhorotsqu', label: 'ჩხოროწყუ', image: cityImage, popular: 0 },
    { value: 'tsageri', label: 'ცაგერი', image: cityImage, popular: 0 },
    // { value: 'tsemi', label: 'ცემი', image: cityImage, popular: 0 },
    // { value: 'tsikhisdziri', label: 'ციხისძირი', image: cityImage, popular: 0 },
    // { value: 'tskhvarichamia', label: 'ცხვარიჭამია', image: cityImage, popular: 0 },
    { value: 'tskhinvali', label: 'ცხინვალი', image: cityImage, popular: 0 },
    { value: 'tsalenjikha', label: 'წალენჯიხა', image: cityImage, popular: 0 },
    { value: 'tsalka', label: 'წალკა', image: cityImage, popular: 0 },
    { value: 'tsaghveri', label: 'წაღვერი', image: cityImage, popular: 0 },
    // { value: 'tserovani', label: 'წეროვანი', image: cityImage, popular: 0 },
    // { value: 'tsilkani', label: 'წილკანი', image: cityImage, popular: 0 },
    // { value: 'tsinandali', label: 'წინანდალი', image: cityImage, popular: 0 },
    // { value: 'tsitsamuri', label: 'წიწამური', image: cityImage, popular: 0 },
    { value: 'tsnori', label: 'წნორი', image: cityImage, popular: 0 },
    { value: 'tsqaltubo', label: 'წყალტუბო', image: cityImage, popular: 1 },
    { value: 'chiatura', label: 'ჭიათურა', image: cityImage, popular: 0 },
    //{ value: 'choporti', label: 'ჭოპორტი', image: cityImage, popular: 0 },
    { value: 'kharagauli', label: 'ხარაგაული', image: cityImage, popular: 0 },
    // { value: 'khashmi', label: 'ხაშმი', image: cityImage, popular: 0 },
    { value: 'khashuri', label: 'ხაშური', image: cityImage, popular: 0 },
    // { value: 'khevsureti', label: 'ხევსურეთი', image: cityImage, popular: 0 },
    { value: 'khelvachauri', label: 'ხელვაჩაური', image: cityImage, popular: 0 },
    { value: 'khobi', label: 'ხობი', image: cityImage, popular: 0 },
    { value: 'khoni', label: 'ხონი', image: cityImage, popular: 0 },
    { value: 'khulo', label: 'ხულო', image: cityImage, popular: 0 },
    // { value: 'kachreti', label: 'კაჭრეთი', image: cityImage, popular: 0 },
    { value: 'java', label: 'ჯავა', image: cityImage, popular: 0 },
    // ჩამატებული ქალაქები და დაბები
    { value: 'kvaisa', label: 'კვაისა', image: cityImage, popular: 0 },
    { value: 'miusera', label: 'მიუსერა', image: cityImage, popular: 0 },
    { value: 'leselidze', label: 'ლესელიძე', image: cityImage, popular: 0 },
    { value: 'gantiani', label: 'განთიადი', image: cityImage, popular: 0 },
    { value: 'bichvinta', label: 'ბიჭვინთა', image: cityImage, popular: 0 },
    { value: 'laituri', label: 'ლაითური', image: cityImage, popular: 0 },
    { value: 'ochkhmuri', label: 'ოჩხამური', image: cityImage, popular: 0 },
    { value: 'kvemo_nasakirali', label: 'ქვედა ნასაკირალი', image: cityImage, popular: 0 },
    { value: 'naruja', label: 'ნარუჯა', image: cityImage, popular: 0 },
    { value: 'kulashi', label: 'კულაში', image: cityImage, popular: 0 },
    { value: 'tamarisi', label: 'თამარისი', image: cityImage, popular: 0 },
    { value: 'trialeti', label: 'თრიალეთი', image: cityImage, popular: 0 },
    { value: 'bediani', label: 'ბედიანი', image: cityImage, popular: 0 },
    { value: 'kharistvala', label: 'ხარისთვალა', image: cityImage, popular: 0 },
    { value: 'gomismta', label: 'გომისმთა', image: cityImage, popular: 0 },
    { value: 'vale', label: 'ვალე', image: cityImage, popular: 0 },
    { value: 'jvari', label: 'ჯვარი', image: cityImage, popular: 0 },
    { value: 'sokhumi', label: 'სოხუმი', image: cityImage, popular: 0 },
    { value: 'gagra', label: 'გაგრა', image: cityImage, popular: 0 },
    { value: 'gudauta', label: 'გუდაუთა', image: cityImage, popular: 0 },
    { value: 'gali', label: 'გალი', image: cityImage, popular: 0 },
    { value: 'ochamchire', label: 'ოჩამჩირე', image: cityImage, popular: 0 },
    { value: 'tkvarcheli', label: 'ტყვარჩელი', image: cityImage, popular: 0 },
    { value: 'akhali_atoni', label: 'ახალი ათონი', image: cityImage, popular: 0 },
    
];

export const destrictOptions = [
    { value: 'gldani', label: 'გლდანის რაიონი', image: destrict },
    { value: 'didube', label: 'დიდუბის რაიონი', image: destrict },
    { value: 'vake', label: 'ვაკის რაიონი', image: destrict },
    { value: 'isani', label: 'ისნის რაიონი', image: destrict },
    { value: 'krtsanisi', label: 'კრწანისის რაიონი', image: destrict },
    { value: 'mtatsminda', label: 'მთაწმინდის რაიონი', image: destrict },
    { value: 'nadzaladevi', label: 'ნაძალადევის რაიონი', image: destrict },
    { value: 'saburtalo', label: 'საბურთალოს რაიონი', image: destrict },
    { value: 'samgori', label: 'სამგორის რაიონი', image: destrict },
    { value: 'chughureti', label: 'ჩუღურეთის რაიონი', image: destrict },
];

// დამატებული
export const ubani = [
    { city: 'tbilisi', destrict: 'gldani', value: 'avchala', label: 'ავჭალა' },
    // ჩასწორებული
    { city: 'tbilisi', destrict: 'gldani', value: 'gldani', label: 'გლდანის მიკრო რაიონები' },
    { city: 'tbilisi', destrict: 'gldani', value: 'gldanula', label: 'გლდანულა' },
    { city: 'tbilisi', destrict: 'gldani', value: 'mukhiani', label: 'მუხიანი' },
    { city: 'tbilisi', destrict: 'gldani', value: 'sofeligldani', label: 'სოფელი გლდანი' },
    { city: 'tbilisi', destrict: 'gldani', value: 'zahesi', label: 'ზაჰესი' },
    { city: 'tbilisi', destrict: 'gldani', value: 'koniakisdasaxleba', label: 'კონიაკის დასახლება' },
    { city: 'tbilisi', destrict: 'gldani', value: 'giorgiwminda', label: 'გიორგიწმინდას დასახლება' },
    { city: 'tbilisi', destrict: 'gldani', value: 'muxianisdachebi', label: 'მუხიანის დაჩები' },
    { city: 'tbilisi', destrict: 'gldani', value: 'franguliubani', label: 'ფრანგული უბანი' },
    { city: 'tbilisi', destrict: 'gldani', value: 'xelosnebisubani', label: 'ხელოსნების ქალაქი' },
    { city: 'tbilisi', destrict: 'gldani', value: 'diditbismidamo', label: 'დიდი ტბის მიდამოები' },
    { city: 'tbilisi', destrict: 'isani', value: 'avlabari', label: 'ავლაბარი' },
    // დამატებლი
    { city: 'tbilisi', destrict: 'isani', value: 'zemo-avlabari', label: 'ზემო ავლაბარი' },
    { city: 'tbilisi', destrict: 'isani', value: 'iveria-places', label: 'ივერიის ხვთისმშობლის ტაძრის მოდამოები' },
    // დამატებლი
    { city: 'tbilisi', destrict: 'isani', value: 'metexisubani', label: 'მეტეხის უბანი' },
    { city: 'tbilisi', destrict: 'isani', value: 'riye', label: 'რიყე' },
    { city: 'tbilisi', destrict: 'isani', value: 'elia', label: 'ელია' },
    { city: 'tbilisi', destrict: 'isani', value: 'isani', label: 'ისანი' },
    { city: 'tbilisi', destrict: 'isani', value: '300aragveli', label: '300 არაგველი' },
    { city: 'tbilisi', destrict: 'isani', value: 'vazisubani', label: 'ვაზისუბანი' },
    { city: 'tbilisi', destrict: 'isani', value: 'mervelegioni', label: 'მერვე ლეგიონი' },
    { city: 'tbilisi', destrict: 'isani', value: 'metromSeni', label: 'მეტრომშენი' },
    { city: 'tbilisi', destrict: 'isani', value: 'navtlugi', label: 'ნავთლუღი' },
    { city: 'tbilisi', destrict: 'isani', value: 'dirsichala', label: 'დირსი ჭალა' },
    { city: 'tbilisi', destrict: 'isani', value: 'marcxenasanapiroisani', label: 'მარცხენა სანაპირო' },
    { city: 'tbilisi', destrict: 'isani', value: 'maxata', label: 'მახათა' },
    { city: 'tbilisi', destrict: 'isani', value: 'tadzrisubani', label: 'ტაძრის უბანი' },
    { city: 'tbilisi', destrict: 'isani', value: 'choloyashvilisubani', label: 'ჩოლოყაშვილის უბანი' },

    { city: 'tbilisi', destrict: 'chughureti', value: 'arsenali', label: 'არსენალი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'dzvelikukia', label: 'ძველი კუკია' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'axalikukia', label: 'ახალი კუკია' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'chugureti', label: 'ჩუღურეთი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'svanetisubani', label: 'სვანეთის უბანი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'oqrosubani', label: 'ოქროს უბანი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'voroncovi', label: 'ვორონცოვი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'zaarbrukeni', label: 'ზაარბრუკენის მოედანი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'plexanovi', label: 'პლეხანიოვი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'ivertubani', label: 'ივერთ უბანი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'marcxenasanapirochugureti', label: 'მარცხენა სანაპირო' },
    // დამატებული უბანი
    { city: 'tbilisi', destrict: 'chughureti', value: 'new_army_city', label: 'ახალი სამხედრო ქალაქი' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'dendrology_paces', label: 'დენდროლოგიური პარკის მიდამოები' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'maxatis_mtis_midamoebi', label: 'მახათის მთის მიდამოები' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'xexil-sanerge', label: 'ხეხილ სანერგე მეურნეობა' },
    // დამატებული უბანი
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'abanotubani', label: 'აბანოთუბანი' },
    // გადაკეთებული სახელებით
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'zemochala', label: 'ზემო კალა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'qvemochala', label: 'ქვემო კალა' },
    // გადაკეთებული სახელებით
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'anchisxati', label: 'ანჩისხატის უბანი' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'patarasirachxana', label: 'პატარა სირაჩხანა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'legvtaxevi', label: 'ლეღვთა ხევი' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'betlemi', label: 'ბეთლემი კლდისუბანი' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'krtsanisi', label: 'კრწანისი' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'ortachala', label: 'ორთაჭალა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'didixeivani', label: 'დიდი ხეივანი' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'xarfuxi', label: 'ხარფუხი' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'zemofonichala', label: 'ზემო ფონიჭალა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'qvemofonichala', label: 'ქვემო ფონიჭალა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'marjvenasanapirokrtsanisi', label: 'მარჯვენა სანაპირო' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'nariyala', label: 'ნარიყალა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'fonichala', label: 'ფონიჭალა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'mtatsminda', label: 'მთაწმინდა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'sololaki', label: 'სოლოლაკი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'tavisufleba', label: 'თავისუფლების მოედანი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'respublikismoedani', label: 'რესპუბლიკის მოედანი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'vera', label: 'ვერა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'zemeli', label: 'ზემელი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'orbeliani', label: 'ორბელიანის მოედანი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'garetubani', label: 'გარეთუბანი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'iamurka', label: 'იარმურკა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'fiqrisgora', label: 'ფიქრის გორა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'semionovka', label: 'სემიონოვკა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'marjvenasanapiromtatsminda', label: 'მარჯვენა სანაპირო' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'oqroyana', label: 'ოქროყანა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'wavkisi', label: 'წავკისი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'wavkisicheroni', label: 'წავკისი-ჩერონი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'wavkisisveli', label: 'წავკისის ველი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'shindisi', label: 'შინდისი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'tabaxmela', label: 'ტაბახმელა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'kojori', label: 'კოჯორი' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'kikeTi', label: 'კიკეთი' },
    { city: 'tbilisi', destrict: 'didube', value: 'didube', label: 'დიდუბე' },
    { city: 'tbilisi', destrict: 'didube', value: 'digmismasivi', label: 'დიღმის მასივი' },
    // ჩასწორებული
    { city: 'tbilisi', destrict: 'didube', value: 'marcxenasanapirodidube', label: 'მარცხენა(კოსმონავტების) სანაპირო' },
    { city: 'tbilisi', destrict: 'didube', value: 'mushtaetisbagi', label: 'მუშტაეთის ბაღის მიდამოები' },
    { city: 'tbilisi', destrict: 'didube', value: 'digmistye', label: 'დიღმის ტყეპარკის მიდამოები' },
    { city: 'tbilisi', destrict: 'vake', value: 'vake', label: 'ვაკე' },
    { city: 'tbilisi', destrict: 'vake', value: 'bagebi', label: 'ბაგები' },
    { city: 'tbilisi', destrict: 'vake', value: 'mziuri', label: 'მზიურის მიდამოები' },
    { city: 'tbilisi', destrict: 'vake', value: 'amirejibi', label: 'ჭ.ამირეჯიბის გზატკეცილი' },
    { city: 'tbilisi', destrict: 'vake', value: 'kustba', label: 'კუს ტბის მიდამოები' },
    { city: 'tbilisi', destrict: 'vake', value: 'vakisparki', label: 'ვაკის პარკის მიდამოები' },
    { city: 'tbilisi', destrict: 'vake', value: 'kaklebi', label: 'კაკლები' },
    { city: 'tbilisi', destrict: 'vake', value: 'nucubidze', label: 'ნუცუბიძის მიკრორაიონები' },
    { city: 'tbilisi', destrict: 'vake', value: 'tskneti', label: 'წყნეთი' },
    { city: 'tbilisi', destrict: 'vake', value: 'betania', label: 'ბეთანია' },
    { city: 'tbilisi', destrict: 'vake', value: 'kveseti', label: 'კვესეთი' },
    { city: 'tbilisi', destrict: 'vake', value: 'axaldaba', label: 'ახალდაბა' },
    { city: 'tbilisi', destrict: 'vake', value: 'agaraki', label: 'აგარაკი' },
    { city: 'tbilisi', destrict: 'vake', value: 'txinvala', label: 'თხინვალა' },
    { city: 'tbilisi', destrict: 'vake', value: 'maglivi', label: 'მაღლივი უნივერსიტეტი' },
    // { city: 'tbilisi', destrict: 'vake', value: 'lisitopografi', label: 'ლისი ტოპოგრაფი' },
    { city: 'tbilisi', destrict: 'vake', value: 'vajapshavela', label: 'ვაჟა-ფშაველას კვარტლები' },
    { city: 'tbilisi', destrict: 'vake', value: 'bagebisstudqalaqi', label: 'ბაგების სტუდქალაქი' },
    // { city: 'tbilisi', destrict: 'vake', value: 'axaliipodromi', label: 'ახალი იპოდრომის მიდამოები' },
    // დამატებული უბანი
    { city: 'tbilisi', destrict: 'vake', value: 'tbilisisakrebi', label: 'თბილისის აკრები' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'nadzaladevi', label: 'ნაძალადევი (ნახალოვკა)' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'lotkini', label: 'ლოტკინი' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'grmagele', label: 'ღრმაღელე (სანზონა)' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'zgvisubani', label: 'ზღვისუბანი (თემქა)' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'avshiani', label: 'ავშიანი' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'tbilisiszgva', label: 'თბილისის ზღვის მიდამოები' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'elmavaltmshenebeli', label: 'ელმავალთმშენებელის მიდამოები' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'dendrologiuriparki', label: 'დენდროლოგიური პარკის მიდამოები' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'delisi', label: 'დელისი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'vedzisi', label: 'ვეძისი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'saburtalo', label: 'საბურთალო' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'gotua', label: 'გოთუა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'shanxai', label: 'შანხაი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'sairmisgora', label: 'საირმის გორა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'iyaltosgora', label: 'იყალთოს გორა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'saakadze', label: 'სააკაძის მოედანი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'gagarini', label: 'გაგარინის მოედანი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'lisismidamoebi', label: 'ლისის მიდამოები' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'lisiveranda', label: 'ლისი ვერანდა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'vashlijvari', label: 'ვაშლიჯვარი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'sofelidigomi', label: 'სოფელი დიღომი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'gmirtamoedani', label: 'გმირთა მოედანი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'qoshigora', label: 'ქოშიგორა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'dididigomi', label: 'დიდი დიღომი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'digmisveli', label: 'დიღმისველი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'digomi19', label: 'დიღომი 1-9' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'pataradigomi', label: 'პატარა დიღომი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'digmischala', label: 'დიღმის ჭალა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'zurgovana', label: 'ზურგოვანა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'telovani', label: 'თელოვანი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'sauniversitetodigomi', label: 'დიდი დიღმის საუნივერსიტეტო დასახლება' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'dzveliipodromi', label: 'ძვ. იპოდრომის მიდამოები' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'marjvenasanapirosaburtalo', label: 'მარჯვენა სანაპირო' },
    // { city: 'tbilisi', destrict: 'saburtalo', value: 'amirejibisgzatkecili', label: 'ჭ.ამირეჯიბის გზატკეცილი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'diplomatiurisofeli', label: 'თბილისის დიპლომატიური სოფელი' },
    // { city: 'tbilisi', destrict: 'saburtalo', value: 'axalitbilisi', label: 'ახალი თბილისი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'axalidigomi', label: 'ახალი დიღომი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'dzvelivedzisi', label: 'ძველი ვეძისი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'didgori', label: 'დიდგორი' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'digomi', label: 'დიღომი' },
    // დამატებული უბანი
    { city: 'tbilisi', destrict: 'saburtalo', value: 'new_ipodrom', label: 'ახალი იპოდრომის მიდამოები' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'xiliani_places', label: 'ხილიანის მიდამოები' },
    // დამატებული უბანი
    { city: 'tbilisi', destrict: 'samgori', value: 'varketili', label: 'ვარკეთილი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'mesamemasivi', label: 'მესამე მასივი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'hualingi', label: 'ჰუალინგი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'orkhevi', label: 'ორხევი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'samgori', label: 'ზემო სამგორი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'qvemosamgori', label: 'ქვემო სამგორი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'aleqseevka', label: 'ალექსეევკა' },
    { city: 'tbilisi', destrict: 'samgori', value: 'aeroportisdasaxleba', label: 'აეროპორტის დასახლება' },
    { city: 'tbilisi', destrict: 'samgori', value: 'afrika', label: 'აფრიკა' },
    { city: 'tbilisi', destrict: 'samgori', value: 'dampalo', label: 'დამპალოს დასახლება' },
    { city: 'tbilisi', destrict: 'samgori', value: 'zeemka', label: 'ზეემკა' },
    { city: 'tbilisi', destrict: 'samgori', value: 'lilosdasaxleba', label: 'ლილოს დასახლება' },
    { city: 'tbilisi', destrict: 'samgori', value: 'didililo', label: 'დიდი ლილო' },
    { city: 'tbilisi', destrict: 'samgori', value: 'pataralilo', label: 'პატარა ლილო' },
    { city: 'tbilisi', destrict: 'samgori', value: 'varketilismeurneoba', label: 'ვარკეთილის მეურნეობა' },
    { city: 'tbilisi', destrict: 'samgori', value: 'aeroportisgzatkecili', label: 'აეროპორტის გზატკეცილი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'nasaguri', label: 'ნასაგური' },
    { city: 'tbilisi', destrict: 'samgori', value: 'winubani', label: 'წინუბანი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'moskovisgamziri', label: 'მოსკოვის გამზირი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'pepela', label: 'პეპელა' },
    { city: 'tbilisi', destrict: 'samgori', value: 'mtkvrismarcxenasanapiro', label: 'მტკვრის მარცხენა სანაპირო' },
    { city: 'tbilisi', destrict: 'samgori', value: 'gardabnisgzatkecili', label: 'გარდაბნის გზატკეცილი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'broweula', label: 'ბროწეულა' },
    // დამატებული უბანი
    { city: 'tbilisi', destrict: 'samgori', value: 'istpointi', label: 'ისთ პოინტის მიდამოები' },
    { city: 'tbilisi', destrict: 'samgori', value: 'tetrixevi', label: 'თეთრი ხევი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'tbilisizghvisplaza', label: 'თბილისის ზღვის პლაზის მიდამოები' },
    { city: 'tbilisi', destrict: 'samgori', value: 'varketili_2', label: 'ვარკეთილის მე-2 რიგი' },
    { city: 'tbilisi', destrict: 'samgori', value: 'varketili_zemo_plato_2', label: 'ვარკეთილის ზემო პლატო 2' },
    // დამატებული უბანი
    { city: 'batumi', destrict: 'batumi', value: 'dzvelibatumi', label: 'ძველი ბათუმის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'rustavelisubani', label: 'რუსთაველის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'ximshiashvili', label: 'ხიმშიაშვილის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'bagrationi', label: 'ბაგრატიონის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'agmashenebeli', label: 'აღმაშენებლის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'javakhishvili', label: 'ჯავახიშვილის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'tamarisubani', label: 'თამარის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'bonigorodoki', label: 'ბონი-გოროდოკის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'aeroporti', label: 'აეროპორტის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'kakhaberi', label: 'კახაბრის უბანი' },
    { city: 'batumi', destrict: 'batumi', value: 'makhinjauri', label: 'მახინჯაური' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'avtoqarxana', label: 'ავტოქარხანა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'nikea', label: 'ნიკეა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'bjolevi', label: 'ბჟოლები' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'gora', label: 'გორა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'choma', label: 'ჭომა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'mwvaneyvavila', label: 'მწვანეყვავილა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'shaomiani', label: 'შაომიანი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'mefetubani', label: 'მეფეთუბანი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'zastava', label: 'ზასტავა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'balakvani', label: 'ბალახვანი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'safichxia', label: 'საფიჩხია' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'steklotara', label: 'სტეკლოტარა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'pasiloki', label: 'პასილოკი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'sagoria', label: 'საღორია' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'chavchavadze', label: 'ჭავჭავაძე' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'ninoshvili', label: 'ნინოშვილი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'agmashenebeli', label: 'აღმაშენებელი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'asatiani', label: 'ასათიანი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'avangardi', label: 'ავანგარდი' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'plashadka', label: 'პლაშადკა' },
    { city: 'rustavi', destrict: 'rustavi', value: 'baratashvili', label: 'ნიკოლოზ ბარათაშვილის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'dzvelirustavi', label: 'ძველი რუსთავი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'agmashenebeli', label: 'დავით აღმაშენებლის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'gorgasali', label: 'ვახტანგ გორგასლის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'shartava', label: 'ჟიული შარტავას უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'chkondideli', label: 'გიორგი ჭყონდიდელის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'rustaveli', label: 'შოთა რუსთაველის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'chavchavadze', label: 'ილია ჭავჭავაძის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'tsurtaveli', label: 'იაკობ ცურტაველის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'asureli', label: 'ცამეტი ასურელი მამის უბანი' },
    { city: 'rustavi', destrict: 'rustavi', value: 'axalirustavi', label: 'ახალი რუსთავი' },
    { city: 'tbilisi', destrict: 'gldani', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'didube', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'vake', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'isani', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'krtsanisi', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'mtatsminda', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'nadzaladevi', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'saburtalo', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'samgori', value: 'sxva', label: 'სხვა' },
    { city: 'tbilisi', destrict: 'chughureti', value: 'sxva', label: 'სხვა' },
    { city: 'batumi', destrict: 'batumi', value: 'sxva', label: 'სხვა' },
    { city: 'kutaisi', destrict: 'kutaisi', value: 'sxva', label: 'სხვა' },
    { city: 'rustavi', destrict: 'rustavi', value: 'sxva', label: 'სხვა' },
];

// დამატებული
export const buildyears = [
    { value: 'buildyear1', label: '< 1920' },
    { value: 'buildyear2', label: '1920 - 1955' },
    { value: 'buildyear3', label: '1955 - 1980' },
    { value: 'buildyear4', label: '1980 - 2000' },
    { value: 'buildyear5', label: '2000 - 2020' },
    { value: 'buildyear6', label: '> 2020' },
];

export const districtOptions = [
    { value: 'apkhazeti', label: 'აფხაზეთი' },
    { value: 'achara', label: 'აჭარა' },
    { value: 'guria', label: 'გურია' },
    { value: 'imereti', label: 'იმერეთი' },
    { value: 'kakheti', label: 'კახეთი' },
    { value: 'mtskhetamtianeti', label: 'მცხეთა-მთიანეთი' },
    { value: 'rachalechkhumi', label: 'რაჭა-ლეჩხუმი და ქვემო სვანეთი' },
    { value: 'samegrelozemosvaneti', label: 'სამეგრელო-ზემო სვანეთი' },
    { value: 'samtskhejavakheti', label: 'სამცხე-ჯავახეთი' },
    { value: 'kvemokartli', label: 'ქვემო ქართლი' },
    { value: 'shidakartli', label: 'შიდა ქართლი' },
];

export const municipalOptions = [
    { value: 'abasha', label: 'აბაშის მუნიციპალიტეტი' },
    { value: 'adigeni', label: 'ადიგენის მუნიციპალიტეტი' },
    { value: 'khulo', label: 'ხულოს მუნიციპალიტეტი' },
    { value: 'ambrolauri', label: 'ამბროლაურის მუნიციპალიტეტი' },
    { value: 'aspindza', label: 'ასპინძის მუნიციპალიტეტი' },
    // { value: 'apkhazeti', label: 'აფხაზეთის ავტონომიური რესპუბლიკა' },
    { value: 'khoni', label: 'ხონის მუნიციპალიტეტი' },
    { value: 'akhalkalaki', label: 'ახალქალაქის მუნიციპალიტეტი' },
    { value: 'khobi', label: 'ხობის მუნიციპალიტეტი' },
    { value: 'khelvachauri', label: 'ხელვაჩაურის მუნიციპალიტეტი' },
    { value: 'akhaltsikhe', label: 'ახალციხის მუნიციპალიტეტი' },
    { value: 'khashuri', label: 'ხაშურის მუნიციპალიტეტი' },
    { value: 'akhmeta', label: 'ახმეტის მუნიციპალიტეტი' },
    { value: 'baghdati', label: 'ბაღდათის მუნიციპალიტეტი' },
    { value: 'bolnisi', label: 'ბოლნისის მუნიციპალიტეტი' },
    { value: 'borjomi', label: 'ბორჯომის მუნიციპალიტეტი' },
    { value: 'kharagauli', label: 'ხარაგაულის მუნიციპალიტეტი' },
    { value: 'gardabni', label: 'გარდაბნის მუნიციპალიტეტი' },
    { value: 'gori', label: 'გორის მუნიციპალიტეტი' },
    { value: 'tsqaltubo', label: 'წყალტუბოს მუნიციპალიტეტი' },
    { value: 'tsalka', label: 'წალკის მუნიციპალიტეტი' },
    { value: 'gurjaani', label: 'გურჯაანის მუნიციპალიტეტი' },
    { value: 'tsalenjikha', label: 'წალენჯიხის მუნიციპალიტეტი' },
    { value: 'dedoplistsqaro', label: 'დედოფლისწყაროს მუნიციპალიტეტი' },
    { value: 'dmanisi', label: 'დმანისის რაიონი' },
    { value: 'tskhinvali', label: 'ცხინვალის რაიონი' },
    { value: 'tsageri', label: 'ცაგერის მუნიციპალიტეტი' },
    { value: 'chkhorotsqu', label: 'ჩხოროწყუს მუნიციპალიტეტი' },
    { value: 'vani', label: 'ვანის მუნიციპალიტეტი' },
    { value: 'zestaponi', label: 'ზესტაფონის მუნიციპალიტეტი' },
    { value: 'zugdidi', label: 'ზუგდიდის მუნიციპალიტეტი' },
    { value: 'chokhatauri', label: 'ჩოხატაურის მუნიციპალიტეტი' },
    { value: 'shuakhevi', label: 'შუახევის მუნიციპალიტეტი' },
    { value: 'tetritsqaro', label: 'თეთრიწყაროს მუნიციპალიტეტი' },
    { value: 'telavi', label: 'თელავის მუნიციპალიტეტი' },
    { value: 'qvareli', label: 'ყვარლის მუნიციპალიტეტი' },
    { value: 'terjola', label: 'თერჯოლის მუნიციპალიტეტი' },
    { value: 'tianeti', label: 'თიანეთის მუნიციპალიტეტი' },
    { value: 'qazbegi', label: 'ყაზბეგის მუნიციპალიტეტი' },
    { value: 'kutaisi', label: 'ქუთაისის მუნიციპალიტეტი' },
    { value: 'kobuleti', label: 'ქობულეთის მუნიციპალიტეტი' },
    { value: 'kaspi', label: 'კასპის მუნიციპალიტეტი' },
    { value: 'lagodekhi', label: 'ლაგოდეხის მუნიციპალიტეტი' },
    { value: 'keda', label: 'ქედის მუნიციპალიტეტი' },
    { value: 'lanchkhuti', label: 'ლანჩხუთის მუნიციპალიტეტი' },
    { value: 'lentekhi', label: 'ლენტეხის მუნიციპალიტეტი' },
    { value: 'kareli', label: 'ქარელის მუნიციპალიტეტი' },
    { value: 'marneuli', label: 'მარნეულის მუნიციპალიტეტი' },
    { value: 'tqibuli', label: 'ტყიბულის მუნიციპალიტეტი' },
    { value: 'martvili', label: 'მარტვილის მუნიციპალიტეტი' },
    { value: 'sighnaghi', label: 'სიღნაღის მუნიციპალიტეტი' },
    { value: 'senaki', label: 'სენაკის რაიონი' },
    { value: 'sachkhere', label: 'საჩხერის რაიონი' },
    { value: 'mestia', label: 'მესტიის მუნიციპალიტეტი' },
    { value: 'samtredia', label: 'სამტრედიის მუნიციპალიტეტი' },
    { value: 'sagarejo', label: 'საგარეჯოს მუნიციპალიტეტი' },
    { value: 'oni', label: 'ონის რაიონი' },
    { value: 'ozurgeti', label: 'ოზურგეთის მუნიციპალიტეტი' },
    { value: 'ninotsminda', label: 'ნინოწმინდის რაიონი' },
    { value: 'mtskheta', label: 'მცხეთის მუნიციპალიტეტი' },
    { value: 'akhalgori', label: 'ახალგორის მუნიციპალიტეტი' },
    // ჩამატებული მუნიციპალიტეტები
    { value: 'gagra', label: 'გაგრის მუნიციპალიტეტი' },
    { value: 'gali', label: 'გალის მუნიციპალიტეტი' },
    { value: 'gudauta', label: 'გუდაუთის მუნიციპალიტეტი' },
    { value: 'ochamchire', label: 'ოჩამჩირის მუნიციპალიტეტი' },
    { value: 'sokhumi', label: 'სოხუმის მუნიციპალიტეტი' },
    { value: 'kurti', label: 'ქურთის მუნიციპალიტეტი' },
    { value: 'eredvi', label: 'ერედვის მუნიციპალიტეტი' },
    { value: 'javi', label: 'ჯავის რაიონი' },
    { value: 'znau', label: 'ზნაურის რაიონი' },
    // ჩამატებული მუნიციპალიტეტები
];

export const areaTypes = [
    { value: 'universal', label: 'უნივერსალური' },
    { value: 'newlybuiltbuilding', label: 'კორპუსის საოფისე ფართი' },
    { value: 'commercial', label: 'სავაჭრო' },
    { value: 'special', label: 'სპეციალური' },
    { value: 'warehouse', label: 'სასაწყობე' },
    { value: 'industrialspace', label: 'საწარმოო ფართი' },
    { value: 'foodestablishment', label: 'კვების ობიექტი' },
    { value: 'kiosk', label: 'ჯიხური' },
    { value: 'pavilion', label: 'პავილიონი' },
    { value: 'basement', label: 'სარდაფი' },
    { value: 'semibasement', label: 'ნახევარ სარდაფი' },
    { value: 'garage', label: 'ავტოფარეხი' },
    { value: 'autoservice', label: 'ავტო სერვისი' },
    { value: 'carwash', label: 'ავტო სამრეცხაო' },
    { value: 'businessyard', label: 'საქმიანი ეზო' },
    // { value: 'wholebuilding', label: 'მთლიანი შენობა' },
    // { value: 'oldbuilding', label: 'ძველი აშენებული კორპუსი' },
    
];

export const landTypes = [
    { value: 'agricultural', label: 'სასოფლო სამეურნეო' },
    { value: 'nonagricultural', label: 'არასასოფლო სამეურნეო' },
];

export const functgionZones = [
    { value: 'zone1', label: 'ლანდშაფტურ-სარეკრეაციო ზონა (ლსზ)' },
    { value: 'zone2', label: 'სატყეო ზონა' },
    { value: 'zone3', label: 'სასოფლო-სამეურნეო ზონა (სოფზ)' },
    { value: 'zone4', label: 'სარეკრეაციო ზონა 1 (რზ-1)' },
    { value: 'zone5', label: 'სარეკრეაციო ზონა 2 (რზ-2)' },
    { value: 'zone6', label: 'სარეკრეაციო ზონა 3 (რზ-3)' },
    { value: 'zone7', label: 'სპეციალური ზონა 1 (სპეცზ-1)' },
    { value: 'zone8', label: 'საცხოვრებელი ზონა 1 (სზ-1)' },
    { value: 'zone9', label: 'საცხოვრებელი ზონა 2 (სზ-2)' },
    { value: 'zone10', label: 'საცხოვრებელი ზონა 3 (სზ-3)' },
    { value: 'zone11', label: 'საცხოვრებელი ზონა 4 (სზ-4)' },
    { value: 'zone12', label: 'საცხოვრებელი ზონა 5 (სზ-5)' },
    { value: 'zone13', label: 'საცხოვრებელი ზონა 6 (სზ-6)' },
    { value: 'zone14', label: 'სატრანსპორტო ზონა 1 (ტრ-1)' },
    { value: 'zone15', label: 'სატრანსპორტო ზონა 2 (ტრ-2)' },
    { value: 'zone16', label: 'სატრანსპორტო ზონა 3 (ტრ-3)' },
    { value: 'zone17', label: 'საზოგადოებრივ-საქმიანი ზონა 1 (სსზ-1)' },
    { value: 'zone18', label: 'საზოგადოებრივ-საქმიანი ზონა 2 (სსზ-2)' },
    { value: 'zone19', label: 'საზოგადოებრივ-საქმიანი ზონა 3 (სსზ-3)' },
    { value: 'zone20', label: 'სამრეწველო ზონა 1 (ს-1)' },
    { value: 'zone21', label: 'სამრეწველო ზონა 2 (ს-2)' },
    { value: 'zone22', label: 'სანიტარული ზონა (სანზ)' },
];

export const agriculturalTypes = [
    { value: 'homestead', label: 'საკარმიდამო' },
    { value: 'arable', label: 'სახნავი' },
    { value: 'hayfield', label: 'სათიბი' },
    { value: 'pasture', label: 'საძოვარი' },
    { value: 'orchard', label: 'საბაღე' },
    { value: 'vegetablegarden', label: 'საბოსტნე' },
    { value: 'forestry', label: 'სატყეო' },
];

export const agriculturalTypes2 = [
    { value: 'homestead', label: 'საკარმიდამო' },
    { value: 'commercial', label: 'კომერციული' },
    { value: 'special', label: 'სპეციალური' },
    { value: 'investmentconstruction', label: 'საინვესტიციო მშენებლობისთვის' },
    // { value: 'arableland', label: 'სახნავ სათესი' },
];

export const hotelStars = [
    { value: '1star', label: '1 ვარსკვლავი' },
    { value: '2star', label: '2 ვარსკვლავი' },
    { value: '3star', label: '3 ვარსკვლავი' },
    { value: '4star', label: '4 ვარსკვლავი' },
    { value: '5star', label: '5 ვარსკვლავი' },
    { value: '5plusstar', label: '5+ ვარსკვლავი' },
];

export const eatings = [
    { value: 'singleuse', label: 'ერთჯერადი' },
    { value: 'doubleuse', label: 'ორჯერადი' },
    { value: 'tripleuse', label: 'სამჯერადი' },
];

export const businesscenterClasses = [
    { value: 'aaclass', label: 'AA კლასი' },
    { value: 'aclass', label: 'A კლასი' },
    { value: 'bclass', label: 'B კლასი' },
    { value: 'cclass', label: 'C კლასი' },
    { value: 'withoutclass', label: 'კლასის გარეშე' },
];

export const businessIndustryes = [
    { value: 'manufacturingfactory', label: 'წარმოება ქარხანა' },
    { value: 'foodestablishment', label: 'კვების ობიექტი' },
    { value: 'equipmentmachines', label: 'ტექნიკა დანადგარები' },
    { value: 'hotel', label: 'სასტუმრო' },
    { value: 'gasstation', label: 'ბენზინგასამართი სადგური' },
    { value: 'gasstationlicense', label: 'ბენზინგასამართი სადგურის ლიცენზია' },
    { value: 'carwash', label: 'ავტოსამრეცხაო' },
    { value: 'shop', label: 'მაღაზია' },
    { value: 'operatingbusiness', label: 'მოქმედი ბიზნესი' },
    { value: 'construction', label: 'მშენებლობა' },
    { value: 'autopartsbusiness', label: 'ავტონაწილების ბიზნესი' },
    { value: 'furniturebusiness', label: 'ავეჯის ბიზნესი' },
    { value: 'investmentproject', label: 'საინვესტიციო პროექტი' },
    { value: 'buildingmaterials', label: 'სამშენებლო მასალები' },
    { value: 'other', label: 'სხვა' },
];

export const owners = [
    { value: 'individual', label: 'ფიზიკური პირი' },
    { value: 'smallbusiness', label: 'მცირე მეწარმე' },
    { value: 'legalentity', label: 'იურიდიული პირი' },
];

export const ownerTypes = [
    { value: 'owner', label: 'მესაკუთრე' },
    { value: 'lease', label: 'იჯარა' },
    { value: 'legalentity', label: 'იურიდიული პირი' },
];

export const actives = [
    { value: 'yes', label: 'კი' },
    { value: '', label: 'არა' },
];

export const farmTypes = [
    { value: 'cattle', label: 'მსხვილფეხა' },
    { value: 'poultryfarming', label: 'მეფრინველეობა' },
    { value: 'dairyfarm', label: 'რძის ფერმა' },
    { value: 'greenhouse', label: 'სათბური' },
    { value: 'winemaking', label: 'მეღვინეობა' },
    { value: 'vineyard', label: 'ვენახი' },
    { value: 'fruitorchard', label: 'ხეხილი-ბაღი' },
    { value: 'vegetables', label: 'ბოსტნეული' },
    { value: 'berries', label: 'კენკროვანი' },
    { value: 'hazelnuts', label: 'თხილის' },
    { value: 'walnuts', label: 'კაკლის' },
    { value: 'fishfarm', label: 'საკალმახე' },
    { value: 'incubator', label: 'ინკუბატორი' },
    { value: 'storagefridge', label: 'შესანახი მაცივარი' },
    { value: 'breedingfarm', label: 'საჯიშე ფერმერული მეურნეობა' },
    { value: 'other', label: 'სხვა' },
];

export const farmLandTypes = [
    { value: 'agricultural', label: 'სასოფლო სამეურნეო' },
    { value: 'nonagricultural', label: 'არასასოფლო სამეურნეო' },
    // { value: 'commercial', label: 'კომერციული' },
    // { value: 'special', label: 'სპეციალური' },
    // { value: 'investmentconstruction', label: 'საინვესტიციო მშენებლობისთვის' },
];

export const farmAgriculturalTypes = [
    { value: 'arable', label: 'სახნავი' },
    { value: 'hayfield', label: 'სათიბი' },
    { value: 'pasture', label: 'საძოვარი' },
    { value: 'orchard', label: 'საბაღე' },
    { value: 'vegetablegarden', label: 'საბოსტნე' },
    { value: 'homestead', label: 'საკარმიდამო' },
    { value: 'forestry', label: 'სატყეო' },
];

// დამატებული ფერმის ტიპი
export const farmNonAgriculturalTypes = [
    { value: 'homestead', label: 'საკარმიდამო' },
    { value: 'commercial', label: 'კომერციული' },
    { value: 'special', label: 'სპეციალური' },
    { value: 'investmentconstruction', label: 'საინვესტიციო მშენებლობისთვის' },
];

// property field -> options used for it in Add.js (labels for saved values)
export const fieldOptions = {
    property_type: propertyTypeOptions,
    transaction_type: transactionTypeOptions,
    property_status: propertyStatusOptions,
    project: propertyProjectOptions,
    class: propertyProjectClassOptions,
    condition: propertyConditionOptions,
    property_project_exterrior_style: propertyProjectExterriorStyleOptions,
    property_project_style: propertyProjectInteriorStyleOptions,
    build_date: buildyears,
    typeofspace: areaTypes,
    landtype: landTypes,
    agriculturalland: agriculturalTypes,
    agriculturalland2: agriculturalTypes2,
    functionalarea: functgionZones,
    numberofstars: hotelStars,
    food: eatings,
    businesscenterclass: businesscenterClasses,
    businessinvestmentcategory: businessIndustryes,
    owner: owners,
    propertytype: ownerTypes,
    assets: actives,
    farmtype: farmTypes,
    landtype1: farmLandTypes,
    agrilandtype: farmAgriculturalTypes,
    nonagrilandtype: farmNonAgriculturalTypes,
    city: cityOptions,
    destrict: destrictOptions,
    region: districtOptions,
    municipality: municipalOptions,
    metrosstation_options: metroStationOptions,
};
